import React, { useEffect, useContext, useState } from 'react';
import * as queries from '../../../graphql/queries';
import { API, graphqlOperation } from "aws-amplify";
import { Icon, IconButton, MenuItem, Avatar, useMediaQuery, Hidden } from '@material-ui/core';
import { MatxMenu, MatxSearchBox } from 'components';
import NotificationBar from '../../NotificationBar/NotificationBar';
import { Link } from 'react-router-dom';
import ShoppingCart from '../../ShoppingCart/ShoppingCart';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import useAuth from 'app/hooks/useAuth';
import useSettings from 'app/hooks/useSettings';
import { NotificationProvider } from 'app/contexts/NotificationContext';

import { useSelector, useDispatch } from 'react-redux';
import { getShopList } from './thunk';

import axios from 'axios.js';
import history from 'history.js';
import { Auth } from "aws-amplify";

import SettingIcon from 'app/views/Home/SettingIcon/SettingIcon';
import { AppControlContext } from 'app/contexts/AppControlContext';
import { DateContext } from "app/contexts/DateContext";
import moment from 'moment';

const useStyles = makeStyles(({ palette, ...theme }) => ({
  topbar: {
    top: 0,
    zIndex: 96,
    transition: 'all 0.3s ease',
    background:
      'linear-gradient(180deg, rgba(255, 255, 255, 0.95) 44%, rgba(247, 247, 247, 0.4) 50%, rgba(255, 255, 255, 0))',

    '& .topbar-hold': {
      backgroundColor: palette.primary.main,
      height: 80,
      paddingLeft: 18,
      paddingRight: 20,
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 16,
        paddingRight: 16,
      },
      [theme.breakpoints.down('xs')]: {
        paddingLeft: 14,
        paddingRight: 16,
      },
    },
    '& .fixed': {
      boxShadow: theme.shadows[8],
      height: 64,
    },
  },
  userMenu: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    borderRadius: 24,
    padding: 4,
    '& span': {
      margin: '0 8px',
      // color: palette.text.secondary
    },
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 185,
  },
}));



const Layout1Topbar = () => {
  const theme = useTheme();
  const classes = useStyles();
  const { settings, updateSettings } = useSettings();

  const { isAppControl, setIsAppControl } = useContext(AppControlContext)
  //日付のコンテキスト
  const dateContext = useContext(DateContext)
  const { startDate, setStartDate } = useContext(DateContext)
  const { endDate, setEndDate } = useContext(DateContext)

  //const { logout, user } = useAuth();
  const signOut = () => {
    console.log('ログアウト処理')
    Auth.signOut()
      .catch((error) => console.log('サインアウト失敗: ', error))

    //localStorage.removeItem('accessToken');
    //delete axios.defaults.headers.common.Authorization;
    //localStorage.removeItem('jwt_token');
    //delete axios.defaults.headers.common['Authorization'];
    //localStorage.removeItem('auth_user');

    setIsAppControl(false);
    localStorage.removeItem('ssvShops');//選択店舗保持用のストレージ削除

    //期間選択のストレージ削除
    localStorage.removeItem('ssvPeriod');//日・月・年選択
    localStorage.removeItem('ssvPeriodStartDate');//検索開始日
    localStorage.removeItem('ssvPeriodEndDate');//検索終了日

    //期間選択の日付けリセット
    setStartDate(moment().subtract(7, "days").format("YYYY-MM-DD"));
    setEndDate(moment().subtract(0, "day").format("YYYY-MM-DD"));


    history.push('/session/signin');
  }

  const isMdScreen = useMediaQuery(theme.breakpoints.down('md'));
  const fixed = settings?.layout1Settings?.topbar?.fixed;

  //const { shopList, successShopList, messageShopList } = useSelector((state) => state.shopList);

  const [brand, setBrand] = useState('');

  const dispatch = useDispatch();
  useEffect(() => {
    (async () => {
      try {
        //dispatch(getShopList({ limit: 100, offset: 0 }));
        //console.log('店舗一覧hoge')
        dispatch(getShopList());
        //console.log('getShopList : ' + '\n' + getShopList()) //[object Promise]

        //        const res = await API.graphql(graphqlOperation(queries.getShopList))
        //        console.log('`店舗一覧HOGE' + '\n' + JSON.stringify(res.data.getShopList))

        //        const shopList = JSON.stringify(res.data.getShopList);
        //        console.log('`店舗一覧shopList' + '\n' + shopList)

        // setLoad(false)

        const data = await Auth.currentUserInfo();
        setBrand(data.username);

      } catch (e) {
        console.log("error", e);
        // setLoad(false)
        // alertReload(e.errors[0].messageLogin)
      }
    })()
  }, []);

  const updateSidebarMode = (sidebarSettings) => {
    updateSettings({
      layout1Settings: {
        leftSidebar: {
          ...sidebarSettings,
        },
      },
    });
  };

  const handleSidebarToggle = () => {
    let { layout1Settings } = settings;
    let mode;

    if (isMdScreen) {
      mode = layout1Settings.leftSidebar.mode === 'close' ? 'mobile' : 'close';
    } else {
      mode = layout1Settings.leftSidebar.mode === 'full' ? 'close' : 'full';
    }

    updateSidebarMode({ mode });
  };

  {/*}
  const headerSettingIcon = () => {
    console.log('brand = ' + brand)
    return <SettingIcon />
  }
*/}

  //ヘッダー 設定 ログアウト
  return (
    <div className={classes.topbar}>
      <div className={clsx({ 'topbar-hold': true, fixed: fixed })}>
        <div className="flex justify-between items-center h-full">
          <div className="flex">

            {/* サイドバー開閉の三本線 */}
            <IconButton onClick={handleSidebarToggle} className="hide-on-pc">
              <Icon>menu</Icon>
            </IconButton>

            {/* <div className="hide-on-mobile">
              <IconButton>
                <Icon>mail_outline</Icon>
              </IconButton>

              <IconButton>
                <Icon>web_asset</Icon>
              </IconButton>

              <IconButton>
                <Icon>star_outline</Icon>
              </IconButton>
            </div> */}
          </div>
          <div className="flex items-center">
            {/* <MatxSearchBox /> */}
            {/* <NotificationProvider>
              <NotificationBar />
            </NotificationProvider> */}
            {/* 全アカウント　設定へのリンクは非表示
            {(() => {
              if (brand != '' && brand == 'osaka-ohsho') {
                return <SettingIcon />
              }
            })()}
          */}
            <IconButton onClick={() => signOut()} >
              {/* <Icon>exit_to_app</Icon> */}
              <img src={`${process.env.PUBLIC_URL}/assets/Shop/logoutIcon.svg`} alt="" style={{ height: 22, width: 22 }} />
            </IconButton>

            {/* <NotificationBar2 /> */}

            {/* <ShoppingCart /> */}

            {/* <MatxMenu
              menuButton={
                <div className={classes.userMenu}>
                  <Hidden xsDown>
                    <span>
                      Hi <strong>{user.name}</strong>
                    </span>
                  </Hidden>
                  <Avatar className="cursor-pointer" src={user.avatar} />
                </div>
              }
            >
              <MenuItem>
                <Link className={classes.menuItem} to="/">
                  <Icon> home </Icon>
                  <span className="pl-4"> Home </span>
                </Link>
              </MenuItem>
              <MenuItem>
                <Link className={classes.menuItem} to="/page-layouts/user-profile">
                  <Icon> person </Icon>
                  <span className="pl-4"> Profile </span>
                </Link>
              </MenuItem>
              <MenuItem className={classes.menuItem}>
                <Icon> settings </Icon>
                <span className="pl-4"> Settings </span>
              </MenuItem>
              <MenuItem onClick={logout} className={classes.menuItem}>
                <Icon> power_settings_new </Icon>
                <span className="pl-4"> Logout </span>
              </MenuItem>
            </MatxMenu> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Layout1Topbar);
